// import ReportTransferAnalysis from '../components/ui/report-transfer-analysis.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import MaritalBalanceSheet from "../components/ui/report-marital-balance-sheet.js";
//import {useGetMaritalBalanceSheet} from "../api/marital_balance_sheet.js";
import {useGetAccountBalancesByCategory} from "../api/accounts.js"
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

const sampleData = {
    "assets": {
      "Cash": {
        "editable": false,
        "readonly_accounts": [
          { "id": 1, "_displayName": "Bank of America *1234", "account_holder": "Chase Gibbon",
            "latest_balance": { "id": "random1", "_source": "statement", "end_date": "2025-01-31", "end_balance": 50000},
            "respondent_source": .5, "notes": "Alex's payroll is the sole source of funds."},
          { "id": 2, "_displayName": "Suntrust *1111", "account_holder": "Alex Moffitt",
            "latest_balance": {"id": "random2", "_source": "statement", "end_date": "2025-02-28", "end_balance": 60000},
            "petitioner_source": .5, "respondent_source": .5, "notes": "This is a joint account."}
        ],
        "editable_accounts": [
          { "id": 1, "_displayName": "A New Account *8888", "account_holder": "Chase Gibbon",
            "latest_balance":{"id": "random4", "_source": "statement", "end_date": "2025-05-31", "end_balance": 150000},
            "petitioner_source": .3 },
          { "id": 2, "_displayName": "FTX *6666", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "random5", "_source": "statement", "end_date": "2024-11-15", "end_balance": 69000},
            }
        ]
      },
      "Marketable Securities": {
        "editable": true,
        "editable_accounts": [
          { "id": 1, "_displayName": "TD Brokerage *1234", "account_holder": "C.P. Gibbon",
            "latest_balance":{"id": "random6", "_source": "statement", "end_date": "2024-12-31", "end_balance": 12348.25},
            },
          { "id": 2, "_displayName": "Robinhood *1111", "account_holder": "A. Moffitt",
            "latest_balance":{"id": "randomx1", "_source": "statement", "end_date": "2025-05-15", "end_balance": 15001},
            }
        ]
      },
      "Real Estate": {
        "editable": true,
        "editable_accounts": [
          { "id": 1, "_displayName": "Chase's House", "account_holder": "Chase P Gibbon",
            "latest_balance":{"id": "randomx1", "_source": "statement", "end_date": "2025-02-14", "end_balance": 111.25},
            },
          { "id": 2, "_displayName": "Alex's Condo", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randomx2", "_source": "statement", "end_date": "2025-03-15", "end_balance": 3.31},
            }
        ]
      },
      "Vehicles": {
        "editable": true,
        "editable_accounts": [
          { "id": 1, "_displayName": "Chase's Tesla", "account_holder": "Chase P Gibbon",
            "latest_balance":{"id": "randomx3", "_source": "statement", "end_date": "2025-01-31", "end_balance": 50000},
            },
          { "id": 2, "_displayName": "Alex's BMW", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randomz1", "_source": "statement", "end_date": "2025-02-28", "end_balance": 60000},
            }
        ]
      },
      "Other Assets": {
        "editable": true,
        "editable_accounts": [
          { "id": 1, "_displayName": "Chase's Art Collection", "account_holder": "Chase P Gibbon",
            "latest_balance":{"id": "randomzz1", "_source": "statement", "end_date": "2025-05-31", "end_balance": 150000},
            },
          { "id": 2, "_displayName": "Alex's Jewelry", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randomzzz1", "_source": "statement", "end_date": "2024-11-15", "end_balance": 69000},
            }
        ]
      }
    },
    "liabilities": {
      "Credit Cards": {
        "editable": false,
        "readonly_accounts": [
          { "id": 1, "_displayName": "Chase Credit Card *1234", "account_holder": "Chase P Gibbon",
            "latest_balance":{"id": "randoml1", "_source": "statement", "end_date": "2025-01-31", "end_balance": 5000},
            "petitioner_source": .5, "notes": "Chase's personal credit card."},
          { "id": 2, "_displayName": "Alex's Visa *1111", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randoml21", "_source": "statement", "end_date": "2025-02-28", "end_balance": 6000},
            "respondent_source": .5, "notes": "Alex's personal credit card."}
        ],
        "editable_accounts": [
          { "id": 1, "_displayName": "Joint Credit Card *8888", "account_holder": "Chase Gibbon",
            "latest_balance":{"id": "randomlll1", "_source": "statement", "end_date": "2025-05-31", "end_balance": 15000},
            "petitioner_source": .3 },
          { "id": 2, "_displayName": "Joint Visa *6666", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randomlll2", "_source": "statement", "end_date": "2024-11-15", "end_balance": 6900},
            }
        ]
      },
      "Loans": {
        "editable": true,
        "editable_accounts": []
      },
      "Other Liabilities": {
        "editable": true,
        "editable_accounts": [
          { "id": 1, "_displayName": "Chase's Student Loan", "account_holder": "Chase P Gibbon",
            "latest_balance":{"id": "randomlll3", "_source": "statement", "end_date": "2025-01-31", "end_balance": 20000},
            },
          { "id": 2, "_displayName": "Alex's Car Loan", "account_holder": "Alex Moffitt",
            "latest_balance":{"id": "randomllll21", "_source": "statement", "end_date": "2025-02-28", "end_balance": 15000},
            }
          ]
      }
    }
  };

export default function MaritalBalanceSheetReportPage(props) {
    let { data, error, isLoading } = useGetAccountBalancesByCategory();
    console.log(data)
    // const data = sampleData
    // const error = null; // Simulating no error for sample data
    // const isLoading = false; // Simulating data is already loaded for sample data
    return (
      <CaseDatabaseCheck>
        <CurrentCaseRequired>
          {error && <div>Error loading marital balance sheet: {error.message}</div>}
          {isLoading && <div></div>}
          {!data && !isLoading && <div>No marital balance sheet data available.</div>}
          {/* Uncomment the line below to use sample data for testing */}
          {/* <MaritalBalanceSheet initialData={sampleData} /> */}
          {data && <MaritalBalanceSheet initialData={data} />}
        </CurrentCaseRequired>
      </CaseDatabaseCheck>
    );
}